module.exports = __webpack_public_path__ + "img/airline.7fbe453c.png";